export default __webpack_public_path__ + "static/media/close.fe91b063.svg";